// File: src/components/legal/LegalPage.js

import React from 'react';
import styles from './LegalPage.module.css';

function LegalPage({ title, lastUpdated, children }) {
  return (
    <div className={styles.legalPage}>
      <div className={styles.hero}>
        <div className={styles.heroInner}>
          <p className={styles.eyebrow}>Legal</p>
          <h1 className={styles.title}>{title}</h1>
          {lastUpdated && (
            <p className={styles.lastUpdated}>Last updated: {lastUpdated}</p>
          )}
        </div>
      </div>

      <div className={styles.contentWrapper}>
        <div className={styles.content}>
          {children}
        </div>
      </div>
    </div>
  );
}

export default LegalPage;